<template>
  <div>
    <div class="mt-3 mb-3">
      Selecione abaixo a nota fiscal que deseja vincular a esta compra.
    </div>
    <px-search-text class="rounded-tag-small"
                    label="Busque por uma chave de acesso"
                    v-model="searchText"
                    :on-search="onSearch"/>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-if="!loading && !notasFiscais.content.length">
      <div class="text-center grey--text text--darken-1 my-5">
        Nenhuma nota fiscal encontrada
      </div>
    </div>
    <div v-if="!loading && notasFiscais.content.length">
      <v-radio-group v-model="localValue">
        <v-row dense no-gutters class="text--primary caption">
          <v-col cols="12" sm="4" class="ml-3">
            Chave
          </v-col>
          <v-col cols="12" sm="3">
            Emissão
          </v-col>
          <v-col cols="12" sm="3">
            Total
          </v-col>
          <v-col cols="12" sm="2">
          </v-col>
        </v-row>
        <v-radio
          v-for="notaFiscal in notasFiscais.content"
          :key="notaFiscal.id"
          :value="notaFiscal"
          class="mr-3"
        >
          <template v-slot:label="">
            <v-row dense no-gutters class="text--primary align-center">
              <v-col cols="12" sm="4">
                <px-nota-fiscal-chave-acesso :nota-fiscal="notaFiscal" />
              </v-col>
              <v-col cols="12" sm="3">
                {{ notaFiscal.dataEmissao | date }}
              </v-col>
              <v-col cols="12" sm="3">
                {{ notaFiscal.totalNotaFiscal | currency }}
              </v-col>
              <v-col cols="12" sm="2">
                <px-nota-fiscal-detalhe-dialog :nota-fiscal="notaFiscal"/>
              </v-col>
            </v-row>
          </template>
        </v-radio>
      </v-radio-group>
    </div>
  </div>
</template>

<script>
import NotasFiscaisService from '@/modules/notas-fiscais/notas-fiscais-service';
import NotaFiscalDetalheDialog from '@/modules/notas-fiscais/detalhes/NotaFiscalDetalheDialog.vue';
import NotaFiscalChaveAcesso from '@/modules/notas-fiscais/NotaFiscalChaveAcesso.vue';

const DEFAULT_LIMIT = 10;

export default {
  props: {
    value: Object,
    compra: {
      type: Object,
      required: true,
    },
    links: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      searchText: null,
      loading: false,
      selected: null,
      notasFiscais: {
        content: [],
        total: 0,
      },
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  methods: {
    buildQuery() {
      const filters = [`fornecedor.id = ${this.compra.fornecedor.id}`, `comprador.id = ${this.compra.comprador.id}`];

      const idsNotasVinculadas = this.links.filter(link => link.notaFiscal)
        .map(link => link.notaFiscal.id);

      if (idsNotasVinculadas.length) {
        filters.push(`id not in (${idsNotasVinculadas.join(',')})`);
      }

      return `${filters.join(' and ')} order by dataEmissao desc`;
    },
    onSearch() {
      this.getNotasFiscaisiscais();
    },
    getNotasFiscaisiscais() {
      NotasFiscaisService.getNotasFiscais({
        limit: DEFAULT_LIMIT,
        offset: 0,
        query: this.buildQuery(),
      })
        .then(({ data }) => {
          this.notasFiscais = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getNotasFiscaisiscais();
  },
  components: {
    pxNotaFiscalDetalheDialog: NotaFiscalDetalheDialog,
    pxNotaFiscalChaveAcesso: NotaFiscalChaveAcesso,
  },
};
</script>
